module.exports = __webpack_public_path__ + "img/28.7.Chla.4ed14903.png";